const initKcabangData = {
  
}


export function kcabangData(
  state = initKcabangData,
  action
) {
  switch (action.type) {
    case "KCABANG_FETCH_DATA_SUCCESS":
      return action.dataKcabang;
    default:
      return state;
  }
}
